<div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
  <div class="bg-white rounded-2xl p-8 max-w-md w-full mx-4 shadow-xl">
    <h2 class="text-2xl font-bold mb-6">Done order reminder</h2>
    
    <div class="space-y-3 mb-6">
      <p class="text-gray-700">
        <span class="font-semibold">{{ usersCount() }}</span> 
        {{ usersCount() === 1 ? 'user' : 'users' }} will receive a notification
      </p>
      
      <p class="text-gray-700">
        <span class="font-semibold">{{ ordersCount() }}</span> 
        {{ ordersCount() === 1 ? 'order' : 'orders' }} ready for pickup
      </p>
      
      <p class="text-gray-600 text-sm">
        @if (lastReminderDate()) {
          Last reminder sent: <span class="font-medium">{{ lastReminderDate() | date:'medium' }}</span>
        } @else {
          No reminders have been sent yet
        }
      </p>
    </div>

    <hr class="border-gray-200 my-6">

    <div class="flex gap-3 justify-end">
      <button
        (click)="onCancel()"
        class="px-6 py-2 rounded-lg border-2 border-gray-300 text-gray-700 font-semibold hover:bg-gray-50 transition-colors"
      >
        Cancel
      </button>
      <button
        (click)="onSend()"
        class="px-6 py-2 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 transition-colors"
      >
        Send
      </button>
    </div>
  </div>
</div>
